import { lazyLoadView } from '@router/routes'
import { i18n } from '@plugins/i18n'
import { ROLE } from '@utils/constant'

const adminListRoutes = {
  path: 'admin-list',
  component: {
    render(c) {
      return c('router-view')
    },
  },
  meta: {
    label: i18n.t('router.admin.list'),
  },
  children: [
    {
      path: '',
      name: 'adminList',
      component: () => lazyLoadView(import('@views/AdminList/list.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
      },
    },
    {
      path: 'registration',
      name: 'adminRegistration',
      component: () =>
        lazyLoadView(import('@views/AdminList/registration.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.admin.add'),
      },
    },
    {
      path: 'edit/:id',
      name: 'editAdmin',
      component: () => lazyLoadView(import('@views/AdminList/edit.vue')),
      meta: {
        authRequired: [ROLE.SUPER],
        label: i18n.t('router.admin.edit'),
      },
    },
  ],
}

export default adminListRoutes
